export const ActionTypes = {
  LOADING: "GENERATE_AI_DESCRIPTION_DEFINITION_LOADING",
  ERROR: "GENERATE_AI_DESCRIPTION_DEFINITION_ERROR",
  SUCCESS: "GENERATE_AI_DESCRIPTION_DEFINITION_SUCCESS",
};
